import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWindsurfNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M30.583 28.719l.689-1.544H20.277l.933-1.745a24.328 24.328 0 000-22.88L19.95.17h-3.42l-10.11 19H4v1.66h17.36a22.33 22.33 0 01-1.6 3.83l-.45.84-6.5-3.02H8.9l9.63 4.48-.113.215H3v1.65h25.516a4.117 4.117 0 01-3.054 1.35H3v1.65h22.46a5.786 5.786 0 005.123-3.106zM17.52 1.83h1.44l.8 1.5a22.19 22.19 0 011.611 3.844h-6.694L17.52 1.83zm-3.73 7h8.029a22.02 22.02 0 01.581 4.345H11.477L13.79 8.83zm-5.5 10.34l2.31-4.344h11.8a22.02 22.02 0 01-.58 4.344H8.29z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWindsurfNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsWindsurfNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWindsurfNormalMedium;
